import React from 'react'
import { useNavigate } from 'react-router-dom'
import './ClickableImageCard.css'

function ClickableImageCard({item}) {
    const navigate = useNavigate();

    const handleClick = () => {
        // navigate(`/bboo/${item.id}/${item.bboo}`);

        navigate(`/bboo/${item.id}`, {state: {itemData: item}});
    }
  return (
    <div className="image-card" onClick={handleClick}>
        <img src={item.image} alt={item.category || 'Product'} />
    </div>
  )
}

export default ClickableImageCard